import type { AccessToken, RefreshToken, Tokens } from "@okta/okta-auth-js";
import { useAuth } from "@okta/okta-vue";

export const refreshAuthTokens = async (
  authClient = useAuth()
): Promise<Tokens> => {
  const authState = authClient.authStateManager.getAuthState();
  // we were authenticated and our refresh token is not expired, so also explicitly renew all tokens in this set
  const newTokens = await authClient.token.renewTokensWithRefresh(
    {},
    authState?.refreshToken as RefreshToken
  );
  // okta does not set the tokens when you call that renew method, so you must set them manually
  authClient.tokenManager.setTokens(newTokens);
  return newTokens;
};
